import React from "react";
import { useTranslation } from "react-i18next";

import { MergedStreakStat } from "@data-types/sport-stats/SportStatsTypes";

export const HeadToHeadItem = (props: { item: MergedStreakStat }) => {
	const { item } = props;
	const { t } = useTranslation();

	return (
		<div className="statistics__row">
			<div className="statistics__col">
				{item.team === "both" ? item.value : (item.homeValue ?? "-")}
			</div>
			<div className="statistics__col">
				{t(`EVENT.STATISTICS.STREAK_STATS.${item.abrv}`, {
					margin: item.margin,
				})}
			</div>
			<div className="statistics__col">
				{item.team === "both" ? item.value : (item.awayValue ?? "-")}
			</div>
		</div>
	);
};
